import React from "react";
import { GiftIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { BookCover } from "./BookCover";
import { bonuses } from "../data/landing";
export function BonusSection() {
  return <section className="bg-gold-light" data-id="element-1" data-mp="22elmswtqrrmi">
      <div className="mx-auto max-w-4xl px-5 py-16 md:py-24" data-id="element-2" data-mp="22dit6h51bb2w">
        <SectionHeading eyebrow="And That's Not All…" title={<>
              You'll Also Get <span className="text-royal" data-id="element-4" data-mp="1annx81mo8n59">5 Exclusive Bonus Guides</span> — FREE!
            </>} subtitle={<>
              <p data-id="element-5" data-mp="15qno1huiz49x">The six main volumes help your child explore the reasons behind Christian faith.</p>
              <p data-id="element-6" data-mp="1jhkfh5cptffe">
                These five special resources help <strong className="font-bold text-ink" data-id="element-7" data-mp="1eq2e4g6s5ctw">YOU</strong> navigate the
                conversations, doubts, and questions that come along the way.
              </p>
            </>} data-id="element-3" data-mp="1yfcs9pqvnppw" />

        <ul className="mt-12 space-y-5" data-id="element-8" data-mp="qy3ossahxgxr">
          {bonuses.map(b => <li key={b.number} className="grid items-center gap-6 rounded-3xl bg-white p-6 shadow-[0_12px_32px_-20px_rgba(143,92,5,0.45)] sm:grid-cols-[160px_1fr] md:p-8" data-id="element-9" data-mp="my378ys3opmh">
              <div className="mx-auto w-44 sm:w-full" data-id="element-10" data-mp="2eqecbparfzte">
                {b.cover ? <img src={b.cover} alt={`Bonus #${b.number} cover: ${b.title}`} loading="lazy" className="h-auto w-full rounded-lg shadow-[0_14px_28px_-14px_rgba(11,24,56,0.45)]" data-id="element-11" data-mp="2jhwcwc8vfydu" /> : <BookCover variant="bonus" kicker={`Bonus #${b.number}`} title={b.coverTitle} color={b.color} icon={b.icon} data-id="element-12" data-mp="2ogfxa87th243" />}
              </div>
              <div data-id="element-13" data-mp="1vs201uojy9tl">
                <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-14" data-mp="1vrikulqadzj9">
                  Bonus #{b.number}
                </p>
                <h3 className="mt-1 font-display text-2xl font-extrabold leading-tight text-ink" data-id="element-15" data-mp="25qhuo7msg17u">{b.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-16" data-mp="3c6tsg7lp7h2w">{b.text}</p>
                <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-leaf-light px-3.5 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-leaf" data-id="element-17" data-mp="3c8wgim3aj04z">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-18" data-mp="1h5i10xnoqalz" />
                  Included Free
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-19" data-mp="1q2sd2l8bu3ry">
          <p className="font-display text-xl font-extrabold text-navy md:text-2xl" data-id="element-20" data-mp="1q1qxc3gd8t3w">
            All 5 Bonus Guides Are Included at No Extra Cost!
          </p>
          
        </div>
      </div>
    </section>;
}